import { render, staticRenderFns } from "./ViewRole.vue?vue&type=template&id=65412695&"
import script from "./ViewRole.vue?vue&type=script&lang=ts&"
export * from "./ViewRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports